import { render, staticRenderFns } from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=template&id=c24d3b1a&scoped=true"
import script from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=style&index=0&id=c24d3b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24d3b1a",
  null
  
)

export default component.exports